import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios"
import 'animate.css';//动画样式
export const bus = new Vue()
//使用antd
import Antd from 'ant-design-vue'
import { message } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(Antd)
message.config({
  maxCount: 1,
});

// ============== 全局所有 message 都会播放提示音 ==============
const playSound = () => {
  const audio = new Audio('/ringtone.mp3');
  audio.play().catch(err => {
    console.log('提示音播放失败（浏览器限制，需先点击页面）', err);
  });
};

// 重写所有类型的提示
const originalError = message.error;
const originalWarning = message.warning;


message.error = function (...args) {
  playSound();
  return originalError(...args);
};
message.warning = function (...args) {
  playSound();
  return originalWarning(...args);
};

Vue.prototype.$message = message;
// ==========================================================

//使用终端模块定义
import TerminalDefine from '@/utils/terminal-define'
Vue.use(TerminalDefine)
//使用系统模块定义
import SystemDefine from '@/utils/system-define'
Vue.use(SystemDefine)

//图片查看器
import Viewer from 'v-viewer'
Vue.use(Viewer)

//配由加载进度条
import NProgress from "nprogress" // 加载进度条
import "nprogress/nprogress.css" // 加载进度条 样式
import '@/static/css/nprogress.less' //加载进度条 自定义样式
NProgress.inc(0.2);
NProgress.configure({
  easing: "ease",
  speed: 50,
  showSpinner: false
});

//全局请求挂载
import instance from './api';
Vue.prototype.$http = instance;

//组件封装挂载
import dialog from './utils/js/dialog'
Vue.prototype.$dialog = dialog;

//工序工具类挂载
import processUtils from './utils/js/processUtils'
Vue.prototype.$processUtils = processUtils;

//挂载全局组件和通用js
import globalMount from '@/utils/global-mount'
globalMount.mount()

//初始化配置引入
import initConfig from '@/utils/initConfig'

//时间处理器挂载
import moment from 'moment'
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
Vue.prototype.$moment = moment;

//全局事件总线
Vue.prototype.$bus = new Vue()

//全局自定义样式
import '@/static/css/public.less'
import '@/static/css/variable.less'
import '@/static/css/common.less'
import '@/static/css/ant-override.less'
import '@/static/css/variable.less'

//全局混入
import mixins from './mixins'
Vue.mixin(mixins)

//挂载切断vm的复制对象方法
Vue.prototype.$copy = (source) => source ? JSON.parse(JSON.stringify(source)) : null

//加载配置文件
axios.get(`/config/config.json?t=${new Date().getTime()}`).then(({data})=>{  
  const serverIp = localStorage.getItem("serverIp")
  data.serverIp = serverIp
  data.pushPort = localStorage.getItem("pushPort")
  let baseUrl = "/api"
  if(serverIp){
      baseUrl = `http://${serverIp}:${localStorage.getItem('serverPort')}`
  }
  data.serverUrl = baseUrl
  Vue.prototype.$config = data; //设置成Vue的全局属性
  console.log(data)
  //初始化配置
  initConfig.init()
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}).catch(()=>{
  message.error("加载配置文件失败")
})